import { API } from '../utils/Helper';
const baseURL = API || 'http://localhost:3009';

const apiClient = {
    get: async (url, options = {}) => {
        const fullUrl = new URL(url.startsWith('http') ? url : baseURL + url);
        if (options.params) {
            Object.keys(options.params).forEach(key => {
                if (options.params[key] !== undefined && options.params[key] !== null) {
                    fullUrl.searchParams.append(key, options.params[key]);
                }
            });
        }
        
        const response = await fetch(fullUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return { data };
    },
    post: async (url, body, options = {}) => {
        const fullUrl = new URL(url.startsWith('http') ? url : baseURL + url);
        
        const response = await fetch(fullUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            },
            body: JSON.stringify(body)
        });
        
        if (!response.ok) {
            let errorMessage = `HTTP error! status: ${response.status}`;
            try {
                const errorData = await response.json();
                if (errorData.error) errorMessage = errorData.error;
                else if (errorData.message) errorMessage = errorData.message;
            } catch (e) {
                // ignore
            }
            throw new Error(errorMessage);
        }
        
        const data = await response.json();
        return { data };
    }
};

export default apiClient;
